import { render } from "./BarraPesquisa.vue?vue&type=template&id=f37c100e&scoped=true"
import script from "./BarraPesquisa.vue?vue&type=script&lang=js"
export * from "./BarraPesquisa.vue?vue&type=script&lang=js"

import "./BarraPesquisa.vue?vue&type=style&index=0&id=f37c100e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37c100e"]])

export default __exports__